<template>
<!--    <v-footer dark padless class="footer">-->
<!--        <v-card flat tile class="footer__card text-center">-->
<!--            <v-card-text class="footer__card__top flex-col-center no-pd-t">-->
<!--                <v-img class="img&#45;&#45;border" height="50px" width="50px" :src="companyImage"></v-img>-->
<!--            </v-card-text>-->

<!--            <v-divider></v-divider>-->

<!--            <v-card-text class="flex-col-center" :style="{'background-color': currentCompany.primaryColor}">-->
<!--                <div class="flex-row-center footer__card__bottom__margin">-->
<!--                    <span :style="{'color': currentCompany.fontColor}"> Feito por</span> <v-img class="logo&#45;&#45;bottom" width="58px" height="30px" src="@/assets/logo-lity-horizontal-branco.png"></v-img>-->
<!--                </div>-->
<!--                -->
<!--                <v-btn :style="{'color': currentCompany.fontColor}" outlined class="custom-btn text-none" href="https://lity.com.br/" target="_blank">-->
<!--                    Crie um site para o meu negócio-->
<!--                </v-btn>-->
<!--            </v-card-text>-->
<!--        </v-card>-->
<!--    </v-footer>-->
</template>

<script>
//Store
import { mapGetters } from "vuex";

export default {
    name: 'Footer',
    computed: {
        ...mapGetters('authenticateStore', {
                companyImage: 'get_currentCompanyImage',
                currentCompany: 'get_currentCompany'
            }
        )
    }
}
</script>

<style scoped>
.footer {
    display: block;
    margin-left: auto;
    margin-right: auto;
    background-color: var(--cor--branco);
    width: 100%;
}
.footer__card {
    width: 100%;
}
.footer__card__top {
    background-color: var(--cor--branco);
}
.footer__card__bottom__margin {
    margin-bottom: 16px;
}
.logo--bottom {
    margin-left: 6px;
}
.img--border {
    border-radius: 10px;
}
</style>